import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ShieldAlert, RefreshCw } from "lucide-react";

const ISSUE_LABEL = (issue) => {
  if (issue === "missing") return "missing";
  if (issue === "expired") return "expired";
  if (issue === "no_expiry_date") return "no expiry date";
  if (issue.startsWith("not_approved:")) return issue.split(":")[1] === "rejected" ? "rejected / revoked" : `not approved (${issue.split(":")[1]})`;
  return issue;
};

// READ-ONLY: approved drivers the mandatory-document rules block, and why. Changes nothing.
export const ComplianceImpactPanel = () => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      setData((await api.get("/admin/compliance/impact")).data);
      setErr(null);
    } catch {
      setErr("Couldn't load the affected drivers report.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  if (err) return <div className="text-sm text-[#991B1B]" data-testid="compliance-impact-error">{err}</div>;
  if (!data) return null;
  return (
    <div className="bg-white border border-border" data-testid="compliance-impact-panel">
      <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-border">
        <div className="flex items-center gap-2">
          <ShieldAlert className={`w-5 h-5 ${data.blocked_drivers ? "text-[#EF4444]" : "text-[#10B981]"}`} />
          <div>
            <div className="font-heading font-black text-base">Affected drivers</div>
            <div className="text-xs text-muted-foreground" data-testid="compliance-impact-summary">
              {data.blocked_drivers} of {data.approved_drivers} approved driver{data.approved_drivers === 1 ? "" : "s"} {data.enforcement_enabled ? "blocked by" : "would be blocked by"} the mandatory-document rules · read-only report{data.enforcement_enabled ? "" : " · enforcement OFF"}
            </div>
          </div>
        </div>
        <button type="button" onClick={load} className="text-muted-foreground hover:text-foreground" data-testid="compliance-impact-refresh">
          <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
        </button>
      </div>
      {data.blocked_drivers > 0 && (
        <div className="divide-y divide-border">
          {data.drivers.map((d) => (
            <div key={d.driver_id} className="px-4 py-2.5" data-testid={`compliance-impact-row-${d.driver_id}`}>
              <div className="flex items-center gap-2 text-sm font-bold">
                {d.name}
                <span className="text-[10px] font-normal text-muted-foreground font-mono-tab">{d.email}</span>
                {d.is_online && <span className="text-[10px] px-1.5 py-0.5 bg-[#ECFDF5] text-[#065F46] border border-[#10B981]">ONLINE</span>}
              </div>
              <div className="flex flex-wrap gap-1.5 mt-1">
                {d.problems.map((p) => (
                  <span key={p.doc_type} className="text-[11px] px-1.5 py-0.5 bg-[#FEF2F2] text-[#991B1B] border border-[#FCA5A5]"
                    data-testid={`compliance-impact-problem-${d.driver_id}-${p.doc_type}`}>
                    {p.doc_label}: {ISSUE_LABEL(p.issue)}{p.issue === "expired" && p.expiry_date ? ` ${p.expiry_date}` : ""}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ComplianceImpactPanel;
